import { ArrowDownIcon, ArrowUpIcon } from "lucide-react";

import { Row, Text } from "@/components";

import { cn } from "@/lib/utils";

// How far the median sits from the 12h target, as the pill under the number.
export const TtfsGoalDelta = ({
  hoursOffGoal,
  textClass,
}: {
  // Null when nothing was screened in the period.
  hoursOffGoal: number | null;
  textClass: string;
}) => {
  /* Render */
  const render = () => {
    if (hoursOffGoal === null) {
      return (
        <Text
          className={cn(
            "truncate font-lever-suisse text-[10px] font-normal",
            textClass,
          )}
        >
          No screens this period
        </Text>
      );
    }

    if (hoursOffGoal === 0) {
      return (
        <Text
          className={cn(
            "truncate font-lever-suisse text-[10px] font-normal",
            textClass,
          )}
        >
          On target
        </Text>
      );
    }

    const isOverGoal = hoursOffGoal > 0;
    const DeltaIcon = isOverGoal ? ArrowUpIcon : ArrowDownIcon;
    return (
      <>
        <DeltaIcon className={cn("h-3 w-3 shrink-0", textClass)} />
        <Row className="items-baseline gap-1">
          <Text
            className={cn(
              "font-lever-suisse text-[10px] font-normal",
              textClass,
            )}
          >
            {Math.abs(hoursOffGoal).toString()}
          </Text>
          <Text
            className={cn(
              "font-lever-suisse text-[10px] font-normal",
              textClass,
            )}
          >
            hrs {isOverGoal ? "over" : "under"} target
          </Text>
        </Row>
      </>
    );
  };

  return render();
};
